import { Column } from "react-table";
import { PermitType } from "../models/PermitType";
import { DataGrid } from "./common/DataGrid";
import { ActionItem } from "./GridActionButton";

interface Props {
  permitTypes?: PermitType[] | null;
  selectedPermitType?: PermitType;
  onPermitTypeClicked: (permitType: PermitType) => void;
  onEditPermitType?: (permitTypeId: string) => void;
  showEditAction?: boolean;
}

const PermitTypesGrid = ({
  permitTypes,
  selectedPermitType,
  onPermitTypeClicked,
  onEditPermitType,
  showEditAction = false,
}: Props) => {
  const actionItems = [
    ...(showEditAction
      ? [
          {
            key: "edit",
            icon: "edit",
            content: "Edit",
            callback: (id: string) => onEditPermitType && onEditPermitType(id),
          },
        ]
      : []),
    {
      key: "delete",
      icon: "delete",
      content: "Delete",
      callback: (id: string) => {},
    },
  ] as ActionItem[];

  const columns: Column<PermitType>[] = [
    {
      Header: "Name",
      id: "Name",
      accessor: (p) => p.name,
    },
    {
      Header: "Blueprint key",
      id: "BlueprintKey",
      accessor: (p) => p.blueprintKey,
    },
  ];

  const handlePermitTypeClicked = (proj: PermitType, i: number) => {
    onPermitTypeClicked(proj);
  };

  return (
    <>
      <DataGrid
        columns={columns}
        actionItems={actionItems}
        actionButtonColumn={columns[0]}
        data={permitTypes ? permitTypes : []}
        selectedRow={selectedPermitType}
        onRowClick={handlePermitTypeClicked}
        onPageInfoChange={() => {}}
        loading={false}
        pageCount={1}
      />
    </>
  );
};

export default PermitTypesGrid;
